import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchArgentinianArticles } from '../features/Articles';
import ArticleCard from './ArticleCard';
import ArticleCardSkeleton from '../components/ArticleCardSkeleton';
import { IoIosArrowDown } from 'react-icons/io';
import { FaCirclePlus } from 'react-icons/fa6';
import { IoIosArrowForward } from 'react-icons/io';

const Section = ({
  sectionTitle,
  section,
  isOnSection,
  headerHeight,
  icon,
  route,
}) => {
  const [visibleArticles, setVisibleArticles] = useState(9); // Number of initially visible articles
  const [buttonPressCount, setButtonPressCount] = useState(0); // Number of times the loadMore button has been pressed.
  const dispatch = useDispatch();
  const {
    argentinianArticles,
    argentinianArticleLoading,
    argentinianArticleError,
  } = useSelector((state) => state.articles);
  const sectionLength = argentinianArticles.filter(
    (article) => article.section === section
  ).length;

  useEffect(() => {
    dispatch(fetchArgentinianArticles());
  }, [dispatch]);

  // Filter articles based on section and return specified number of articles
  const filterArticles = (articles, section, numArticles) => {
    const filteredArticles = articles.filter(
      (article) => article.section === section
    );

    const groupedArticles = {};
    filteredArticles.forEach((article) => {
      if (!groupedArticles[article.author]) {
        groupedArticles[article.author] = [];
      }
      groupedArticles[article.author].push(article);
    });

    const finalArticles = [];
    let hasNextArticle = true;
    let i = 0;
    while (hasNextArticle && finalArticles.length < numArticles) {
      hasNextArticle = false;
      for (const author in groupedArticles) {
        if (groupedArticles[author][i]) {
          finalArticles.push(groupedArticles[author][i]);
          hasNextArticle = true;
          if (finalArticles.length >= numArticles) break;
        }
      }
      i++;
    }
    return finalArticles;
  };

  // Function to load more articles
  const loadMoreArticles = () => {
    setVisibleArticles((prevVisibleArticles) => prevVisibleArticles + 9);
    // Add 1 to buttonPressCount
    setButtonPressCount((prevCount) => prevCount + 1);
  };

  // Filter the visible articles
  const filteredArticles = filterArticles(
    argentinianArticles,
    section,
    visibleArticles
  );

  return (
    <div style={isOnSection ? { paddingTop: headerHeight } : {}}>
      <div className="italic p-3 flex gap-3 items-center text-xl font-bold text-[#34345c] bg-[#d6daf0] border-t border-b border-[#34345c]">
        {icon}
        {sectionTitle}
      </div>

      <div
        className={`flex ${
          isOnSection ? 'flex-col' : 'overflow-auto flex'
        } sm:grid grid-cols-3 gap-5 p-5`}
      >
        {argentinianArticleLoading ? (
          <>
            <ArticleCardSkeleton />
            <ArticleCardSkeleton />
            <ArticleCardSkeleton />
            <ArticleCardSkeleton />
            <ArticleCardSkeleton />
            <ArticleCardSkeleton />
            <ArticleCardSkeleton />
            <ArticleCardSkeleton />
            <ArticleCardSkeleton />
          </>
        ) : (
          filteredArticles.map((article) => (
            <ArticleCard
              author={article.author}
              section={article.section}
              articleTitle={article.articleTitle}
              articleUrl={article.articleUrl}
              imgUrl={article.imgUrl}
              id={article._id}
            />
          ))
        )}

        {!isOnSection ? (
          buttonPressCount < 3 ? (
            <div className="flex items-center sm:hidden">
              <button
                onClick={loadMoreArticles}
                className="text-2xl text-[#34345c] font-bold p-3 rounded-md border-[#34345c] bg-[#d6daf0]"
              >
                <FaCirclePlus />
              </button>
            </div>
          ) : (
            <div className="flex items-center sm:hidden">
              <a
                className="flex items-center justify-center text-lg min-w-[9rem] text-[#34345c] font-bold p-3 rounded-md border-[#34345c] bg-[#d6daf0]"
                href={route}
              >
                Ir a sección
                <IoIosArrowForward />
              </a>
            </div>
          )
        ) : null}
      </div>

      {visibleArticles >= sectionLength ? null : !isOnSection ? (
        buttonPressCount < 3 ? (
          <div className="hidden sm:flex items-center justify-center mb-5">
            <button
              onClick={loadMoreArticles}
              className="flex gap-3 items-center text-xl text-[#34345c] font-bold p-3 rounded-md border-[#34345c] bg-[#d6daf0]"
            >
              Ver más <IoIosArrowDown />
            </button>
          </div>
        ) : (
          <div className="hidden sm:flex items-center justify-center mb-5">
            <a
              className="hidden sm:flex items-center text-lg min-w-[9rem] text-[#34345c] font-bold p-3 rounded-md border-[#34345c] bg-[#d6daf0]"
              href={route}
            >
              Ir a sección
              <IoIosArrowForward />
            </a>
          </div>
        )
      ) : (
        <div className="flex items-center justify-center mb-5">
          <button
            onClick={loadMoreArticles}
            className="flex gap-3 items-center text-xl text-[#34345c] font-bold p-3 rounded-md border-[#34345c] bg-[#d6daf0]"
          >
            Ver más <IoIosArrowDown />
          </button>
        </div>
      )}
    </div>
  );
};

export default Section;
